import React from 'react';
import { createRoot } from 'react-dom/client';
import ProactiveList from './ProactiveList';
import './styles.css';

const container = document.getElementById('proactive-list');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ProactiveList />
    </React.StrictMode>
  );
} else {
  console.error('Error: El contenedor raíz para la aplicación React no fue encontrado.');
}
